const errorMessages: { [key: string]: <T extends Record<string, any>>(details?: Partial<T>) => string } = {
  U010001: (details = {}) => `${details?.email ?? ''} is already registered. If you already have an account, please log in. Otherwise, try a different email.`,
  U010003: () => `The username you entered already exists. Please try a different username.`,
  U010004: (details = {}) => `We couldn’t find an account for ${details?.email ?? ''}. Please check for any typos or sign up if you're new.`,
  U010005: () => `No matching account found. Please double-check your details or contact support.`,
  U010006: () => `Your account is already active. Please log in to continue.`,
  U010009: () =>
    `We were unable to send a message to your mobile at this time. Please check your number and try again or contact support if the issue persists.`,
  U010011: () => `Login failed. Please double-check your username and password.`,
  U010012: () => `Session expired due to inactivity. Please log in again.`,
  U010014: () => `Your account is temporarily locked. Too many failed attempts. Please try again later or contact support.`,
  U010015: () => `Your password has expired. Please contact your administrator to reset it.`,
  U010019: () => `This organization already exists. Please check the details or choose a different name.`,
  U010020: () => `Password reset session expired or invalid. Please request a new link and try again.`,
  U010022: () => `The Password reset link has already been used. Please request a new one to continue.`,
  U010023: () => `Session expired. Please try submitting your request again.`,
  U010028: () => `We couldn’t send the two-factor email. Please check your settings or contact support.`,
  U010029: () => `User ID is missing. Please provide a valid ID and try again.`,
  U010030: () => `We couldn’t find this user account. Please check the details or contact support.`,
  U010031: () => `Authentication token is missing or invalid. Please check and try again.`,
  U010032: () => `This account is inactive. Please activate it to enable access.`,
  U010036: () => `The mobile number format looks incorrect. Please check it and try again.`,
  U010055: () => `OTP session not completed. Please request a new code and try again.`,
  U010064: () => `The uploaded CSV file appears to be invalid. Please check the format and upload again.`,
  U010070: () => `Registration is incomplete. Please finish the registration process to continue.`,
  U010073: () => `This invitation is only valid for pending users. Your account is already active.`,
  U010075: () => `Duplicate email or FCA number found in the CSV. Please ensure each entry is unique.`,
  U010076: () => `This account is inactive. Please contact your administrator to activate it.`,
  U010077: () => 'Your account is not active. Please contact your administrator to activate your account and enable login access.',
  U010078: () => 'Your Zeta account has been deactivated. If this was unexpected, please contact your administrator.',
  U010079: () => 'You can’t deactivate your own super user account. Please ask another administrator to make this change.',
  U010080: () => 'This user can’t be deactivated because their account isn’t currently Active or Locked.',
  U010099: () => 'Access Denied: You don’t have permission to view this page. Please contact your administrator.',
  U010100: () => `Your details doesn't match, Please try again!`,
  U010106: () => `Login failed. Please double-check your username and password`,
  U010107: () => `The current password you entered is incorrect. Please check and try again.`,
  U010111: () => `Access to the platform is temporarily restricted until your KYC review is completed successfully. 
You will be able to log in once verification is approved.`,
  U010140: () => `There’s an invalid field in the onboarding request. Please review and try again.`,
  U010145: () => `Verification Code has expired. Please request a new one.`,
  U010146: () => `Too many verification attempts. Please try again later or contact support.`,

  A010001: () => `Please complete all required fields before proceeding. `,
  A010002: () => `Invalid FCA reference number. Please double-check and try again.`,
  A010008: (details = {}) =>
    `An advisor named ${details?.name ?? ''} with FCA number ${details?.fcaNumber ?? ''} already exists. Please use a different FCA number.`,
  A010017: () => 'This link has expired. Please contact your Financial Advisor to request a new one.',
  A010018: () => 'Objective name already exists',
  A010019: () => 'Plan name already exists',
  A010020: () => `Insurance name already exists in our system`,
  A010021: () => `Duplicate Financial Planning in the Request`,
  A020001: (details = {}) => `The firm reference number ${details?.firmReference ?? ''} was not found in the FCA registry. Please check and try again.`,
  A020002: (details = {}) =>
    `The advisor reference number ${details?.individualReference ?? ''} was not found in the FCA registry. Please check and try again.`,
  A020004: () => 'The FCA reference number could not be found. Please double-check and try again.',
  A020018: () => 'This email is already registered. Ask the client to log in or use a different email.',
  A020019: () => 'This user has already been invited. Check the invitation status or resend if needed.',
  A020021: () => `Your background description exceeds 3000 characters. Please shorten it and try again.`,
  A020022: () =>
    `The selected advisor is not linked to the specified firm in the FCA registry. Please verify the advisor's affiliation with the firm and try again.`,
  A020023: () => `The advisor’s username doesn’t match FCA registry records. Please verify and try again.`,
  A020024: () => `An advisor with these details already exists. Please review or contact support.`,
  A020025: () => `‘Research & Analysis’ can’t be enabled unless ‘Rebalancing’ is also enabled. Please update the settings.`,
  A020028: () => `The advisor’s FCA status is invalid. Please review and update as needed.`,
  A020029: () => 'No advisor found with the provided user details. Please verify and try again.',
  A020031: () => '',
  A020033: () => 'The client and partner cannot share the same email. Use separate emails for each.',
  A020036: () => "Only clients with 'Prospect' or 'Advice' status can be marked as 'Gone Away'. Please update the client’s status and try again.",
  A020050: () => `You’re already registered. Please log in to continue.`,
  A020057: () => `This client has no active engagement case. Please verify before proceeding.`,
  A020058: () => `We couldn’t find the requested user details. Please check and try again.`,
  A020060: () => `Request licence not found`,
  A020062: () => `Advisor does not have an enterprise plan`,
  A020063: () => `Advisor email configuration is disabled`,
  A020068: () => `We couldn’t process your request due to a server error. Please try again shortly.`,
  A020069: () => 'Invalid Mobile Number',
  A020071: () => 'Financial Plan not found',
  A020073: () => `Your onboarding cannot be completed because there is an outstanding billing item linked to your FCA firm.
Please clear the pending bill or contact support to continue.`,
  A030009: () => 'Please clear the pending payment and try again.',

  AI010019: () => 'This link has expired. Please contact your Financial Advisor to request a new one.',
  AI010016: () => 'This link has expired. Please contact your Financial Advisor to request a new one.',

  DC10029: () => 'File exceeds the maximum size of 5MB. Please reduce the file size and try again.',
  DC10030: () => 'This file format isn’t supported. Please upload a supported file type and try again.',

  U010050: () => 'This password has been used before. Please choose a new one.',
  U010066: () => 'The uploaded CSV contains an unsupported role. Please review and update the file before uploading.',
  U010069: () => 'Password cannot be reset. Please try again.',
  U010082: () => 'Access denied: You don’t have permission to view this screen. Please contact your administrator.',

  I010001: () => 'Session information is missing. Please include session details and try again.',
  I010002: () => `A beneficiary with the same name and date of birth already exists. Please remove the duplicate to continue.`,
  I010003: (details = {}) =>
    `An investor named ${details?.firstName ?? ''} ${details?.lastName ?? ''} with date of birth ${details?.dob ?? ''} already exists. Please check for duplicates before proceeding.`,
  I010004: (details = {}) => `A client with tax residency in ${details?.country ?? ''} already exists. Please remove the duplicate entry to continue.`,
  I010005: (details = {}) => `A client with tax residency in ${details?.country ?? ''} already exists. Please remove the duplicate entry to continue.`,
  I010006: () => `A beneficiary with the same name and date of birth already exists. Please review and remove the duplicate entry to proceed.`,
  I010008: () => `We had trouble decrypting this client’s data. Please try again or contact support.`,
  I010017: () => `This email is linked to another client. Please use a unique address or contact support.`,
  I010018: () => `Client and partner emails must be different. Please provide separate addresses.`,
  I010026: () => 'The Risk Tolerance Questionnaire has already been submitted.',
  I010030: () => 'This Risk Tolerance Questionnaire link is invalid or expired. Please request a new link.',
  I010031: () => 'This Risk Tolerance Questionnaire link is invalid or expired. Please request a new link.',
  I010034: () => 'A required field is missing. Please check the form and try again.',
  I010036: () => 'You are already registered. Please log in to your account to access the platform.',
  I010048: () => 'This email is suppressed due to GDPR settings.',
  I010050: () => 'GDPR consent has already been recorded.',
  I010058: () => 'All financial objectives must be included in the suitability report. Ensure all objectives are assigned before proceeding.',
  I010063: () => 'Client Migration record Already Exists',
  I010064: () => 'Client migration record not found.',
  I010065: () => 'Consent has already been given.',
  I010066: () => 'Session has expired. Please log in again.',
  I010084: () => 'KYC is not supported for this client.',
  I010085: () => 'Client not found.',
  I010086: () => 'KYC already initiated for this client.',
  I010087: () => 'KYC is not supported for this client.',
  I020006: () => 'This organisation is already added as a key member.',
  I020010: () => 'This individual is already added as a key member.',
  I020012: () => 'A business client with this registration number already exists. Please review the existing record before proceeding.',
  I040002: () => 'Company status is Dissolved. Please review the entity details before proceeding.',

  PF010007: () => `One or more portfolios in the CSV already exist. Please check and try again.`,
  PF010008: (details = {}) => `Missing field: ${details?.fieldName ?? ''} in the portfolio CSV file. Please check and re-upload.`,
  PF010009: (details = {}) =>
    `Duplicate field ${details?.fieldName ?? ''} with value ${details?.value ?? ''} in row ${details?.rowNumber ?? ''}. Please remove duplicates.`,
  PF010010: (details = {}) =>
    `Mismatched portfolio name (${details?.potfoloiName ?? ''}) in row ${details?.rowNumber ?? ''}. Ensure all rows refer to the same portfolio.`,
  PF010011: () => `Portfolio allocations must total 100%. Please review and adjust accordingly.`,
  PF010012: () => `Rebalancing is not set up in MPS configuration. Please configure it first.`,
  PF010013: () => `The CSV file is empty. Please add portfolio data and try again.`,
  PF010014: () => `The ISIN is not recognized. Please verify and correct it before uploading.`,
  PF010016: () => `Only approved platform names are allowed. Please check and update the entry.`,
  PF010017: () => 'The uploaded file does not match the Portfolio Upload template. Please use the Portfolio Upload template and upload the uploaded csv again.',
  PF010018: () => 'Only csv files are supported for csv upload. Please try again using a .csv file.',
  R010020: () => 'DocuSign link already sent to client',

  F010004: () => 'Could not connect to the FCA server. Please try again shortly or contact support.',
  F010005: () => 'Failed to connect to the FCA server. Please retry later or contact support if needed.',

  TSEM010001: () => `The attachment or document type is missing from the request. Please provide the required details and try again.`,
  TSEM010002: () => `No attachment was found for the specified ID. Please verify the ID and try again.`,
  TSEM010003: () => `This attachment has already been processed.`,

  TSCP010001: () => `Uploaded file type is not supported`,

  D010017: () => 'A meeting is scheduled on the requested date',

  // JAVA ERROR CODES
  FIN10021: () => `Each allocation must not exceed the remaining balance of the selected account. Please review and adjust the allocations accordingly.`,
  FIN10023: () => `Investment amount should be no greater than 20000.`,
  FIN10025: () => `The total investment doesn't match the target. Please check and adjust the values.`,
  FIN10026: () => `Platform is required for this recommendation`,
  FIN10027: () => `Portfolio is required for this recommendation`,
  FIN10028: () => `Target year must be in the future. Please update the value.`,
  FIN10029: () => `Current cost should be greater than 0.`,
  FIN10030: () => `Inflation rate should be greater than 0.`,
  FIN10031: () => `Growth rate must be greater than 0.`,
  FIN10032: () => `This pot can’t be deleted while allocations are still linked. Please remove them first.`,
  FIN10033: () => `This pot can’t be deleted while life events are still linked. Please remove them first.`,
  FIN10034: () => `Asset Allocation Percentage should be greater than 0`,
  FIN10035: () => `Asset Allocation Percentage should not be greater than 100`,
  FIN10036: () => `The total asset allocation for a pot across goals can not exceed more 100%`,
  FIN10037: () => `The transaction date must be in the future. Please pick a date after today.`,
  FIN10038: () => `Transaction value must be greater than £0.`,
  FIN10039: () => `Add at least one investment recommendation to proceed.`,
  FIN10042: () => `The total ISA allowance for a pot can not exceed more than the maximum ISA Allowance`,
  FIN10043: () => `Pot percentage for a goal should be equal to 100`,
  FIN10045: () => `Total lumpsum/monthly amount is not same as targeted lumpsum/monthly amount`,
  FIN10046: () => `Please select or create a pot before you save your recommendation.`,
  FIN10047: () => `Please enter a valid amount - either a monthly contribution or a lump sum greater than zero - to save your recommendation.`,
  FIN10048: () => `Please select a platform before you save your recommendation.`,

  // Plan AI Error Codes
  PLAN_AI_10003: () => 'Plan already exists, Operation not supported.',
  PLAN_AI_10008: () => 'Plan is being generated',
  PLAN_AI_10004: () => 'A plan is already being prepared for this client and advice type. Please wait for it to finish before starting another one.',
  PLAN_AI_10040: () => 'You do not have permission to access this client record.',
  PLAN_AI_10100: () => 'We could not generate this plan just now. Please try again in a moment.',
  PLAN_AI_10101: () => 'We could not refresh this plan just now. Please try again in a moment.',
  PLAN_AI_10102: () => 'We could not queue this client update just now. Please try again in a moment.',
  // Upload Transcript Codes
  T010001: () => 'Invalid JSON request. Please check the data format.',

  TSCP010201: () => 'Advisor user not found',
  TSCP010014: () => 'Retail user not found in the meeting.',

  AI_CONF_10001: () => 'No conflict found for the selected record',
  AI_CONF_10002: () => 'Could not resolve the conflict for this record. Please try again or contact support.',

  // Fact Find report codes
  HTML_SUMMARY_NOT_AVAILABLE: () => `Fact Find report not available. Please regenerate it and try again.`,
  HTML_GENERATION_IN_QUEUE: () => `Factfind report generation is in progress . Please check back momentarily and hit download again.`,
  HTML_SUMMARY_FAILED: () => `We couldn’t build the report. Please regenerate it and try again.`,
  HTML_SUMMARY_IN_PROGRESS: () => `Factfind report generation is in progress. Please check back momentarily.`,
  HTML_SUMMARY_GENERATION_REQUESTED: () => `Factfind report generation is in progress. Please check back momentarily.`,
  HTML_SUMMARY_FAILED_RETRY_SENT: () => `Factfind report generation is in progress. Please check back momentarily.`,
  HTML_SUMMARY_FAILED_RETRY_EXCEEDED: () => `We couldn’t build the report. Please regenerate it and try again.`,
  HTML_CONVERSION_FAILED: () => `We couldn’t build the report. Please regenerate it and try again.`,

  // Wealth Proposal codes
  ERR_AI_RPT_SVC_002: () => `Goal not found`,
  ERR_AI_RPT_SVC_003: () => `Summary not found for client`,
  ERR_AI_RPT_SVC_004: () => `Error generating Wealth Proposal`,
  ERR_AI_RPT_SVC_005: () => `Asset not found`,

  ERR_AI_RPT_SVC_006: () => 'No Template was found for the Firm',
  AGENT_SERVICE_ERROR: () => `We couldn't complete the AI request with the information provided. Please review the request and try again.`,
  LLM_TASK_TEMPORARY_UNAVAILABLE: () => 'We could not complete the AI task just now. Please try again in a moment.',
  LLM_TASK_INTERRUPTED: () => 'The AI task was interrupted before it completed. Please try again.',

  // Suitability Report Error Codes
  RL010001: () =>
    "We couldn't generate the suitability report due to a problem with the data sent. Please review your inputs and try again. If everything looks correct, contact support.",
  RL010002: () =>
    'We hit a temporary glitch while preparing your report. Please try again - this usually sorts itself out. If the issue continues, contact support.',
  RL010003: () => "We weren't able to fetch the report data just now. Please try again. If it still doesn't work after a retry, contact support for help.",
  RL010004: () => "The report content couldn't be processed correctly. Please try regenerating the report. If the issue repeats, contact support.",
  RL010005: () => "We couldn't find the suitability report. It might not have been generated yet or could have been removed. Please check and try again.",
  RL010006: () =>
    "We couldn't locate any previous versions of the report. This may be the first version - try generating a new one or contact support if that's unexpected.",
  RL010007: () => "The AI wasn't able to generate any content just now. This usually resolves on retry - give it another go. If not, contact support.",
  RL010008: () =>
    'Something went wrong while reading the Fact Find information. Please check if the data is complete and valid. If everything looks right, contact support.',
  RL010009: () => "A preview isn't available for this report yet. Try generating the report first or check back shortly.",
  RL010010: () => "We couldn't find the report content needed to generate the view. Try again, and if the problem continues, contact support.",

  LLM0002: () => 'Goal Name already exists.',
  LLM10000: () => 'Unable to load the document at the moment. Please try again later.',
  LLM10001: () => 'Document could not be deleted. Please try again.',
  LLM10002: () => 'Task not found. Unable to start the task.',
  LLM10003: () => 'Task not found. Unable to update the assignee.',
  LLM10004: () => 'Task not found or may have been removed.',
  LLM10005: () => 'Plan not found. Unable to add the product.',
  LLM10006: () => 'Plan not found. Unable to update the product.',
  LLM10007: () => 'No product recommendations available for update.',
  LLM10008: () => 'Product not found. It may have been removed or is unavailable.',
  LLM10009: () => 'Unsupported product type. Cannot map recommendation details.',
  DC10032: () => 'Invalid document status',

  // Document Management
  DC10001: () => 'Field missing in the upload file request.',
  DC10004: () => 'Invalid document type.',
  DC10015: () => 'Root folder already exists.',
  DC10016: () => 'Folder not found.',
  DC10017: () => 'Failed to create new folder.',
  DC10018: () => 'Duplicate document node.',
  DC10019: () => 'Folder template already exists.',
  DC10020: () => 'File depth exceeded.',
  DC10021: () => 'Folder template not found.',
  DC10022: () => 'File is not editable.',
  DC10023: () => 'Failed to move folder.',
  DC10024: () => 'Document category does not exist.',
  DC10025: () => 'Document category "Unclassified" is restricted.',
  DC10026: () => 'Document category name already exists.',
  DC10027: () => 'Special action link already exists.',
  DC10031: () => 'System node name does not exist.',
  DC10033: () => 'Special action name already exists.',
  DC010003: () => 'Document not found.',
  DC10034: () => 'Document not found.',
  DC10038: () => 'The folder you are trying to delete is already linked to a category/subcategory.',
};

export const fallbackMessage = 'Something went wrong. Please try again later.';

export const retryableFallbackMessage = 'We could not complete that request just now. Please try again in a moment.';

function readValue(source: any, path: string[]) {
  return path.reduce((value, key) => (value == null ? undefined : value[key]), source);
}

export function extractErrorCode(errorOrCode?: any): string | undefined {
  if (!errorOrCode) return undefined;
  if (typeof errorOrCode === 'string') return errorOrCode;

  const candidates = [
    errorOrCode?.errorCode,
    readValue(errorOrCode, ['response', 'data', 'errorCode']),
    readValue(errorOrCode, ['response', 'data', 'error', 'errorCode']),
    readValue(errorOrCode, ['response', 'data', 'detail', 'error_code']),
    Array.isArray(readValue(errorOrCode, ['response', 'data', 'error']))
      ? readValue(errorOrCode, ['response', 'data', 'error'])?.[0]?.errorCode
      : undefined,
  ];

  return candidates.find((candidate) => typeof candidate === 'string' && candidate.trim().length > 0);
}

export function extractErrorMessage(errorOrCode?: any): string | undefined {
  if (!errorOrCode || typeof errorOrCode === 'string') return undefined;

  const candidates = [
    readValue(errorOrCode, ['response', 'data', 'message']),
    readValue(errorOrCode, ['response', 'data', 'error', 'message']),
    readValue(errorOrCode, ['response', 'data', 'error']),
    readValue(errorOrCode, ['response', 'data', 'detail', 'message']),
    errorOrCode?.message,
  ];

  return candidates.find((candidate) => typeof candidate === 'string' && candidate.trim().length > 0);
}

export function isRetryableError(errorOrCode?: any): boolean {
  if (!errorOrCode || typeof errorOrCode === 'string') return false;

  const explicitRetryable = [
    errorOrCode?.retryable,
    readValue(errorOrCode, ['response', 'data', 'retryable']),
    readValue(errorOrCode, ['response', 'data', 'error', 'retryable']),
  ].find((candidate) => typeof candidate === 'boolean');

  if (typeof explicitRetryable === 'boolean') {
    return explicitRetryable;
  }

  const status = readValue(errorOrCode, ['response', 'status']);
  return typeof status === 'number' && [429, 500, 502, 503, 504].includes(status);
}

export function getErrorMessage<T extends Record<string, any>>(errorOrCode?: any, details?: T, defaultMessage?: string): string {
  const errorCode = extractErrorCode(errorOrCode);
  const errorMessageTemplate = errorCode ? errorMessages[errorCode] : undefined;
  if (errorMessageTemplate) {
    return errorMessageTemplate(details);
  }

  const serviceMessage = extractErrorMessage(errorOrCode);
  if (serviceMessage) {
    return serviceMessage;
  }

  if (isRetryableError(errorOrCode)) {
    return defaultMessage || retryableFallbackMessage;
  }

  return defaultMessage || fallbackMessage;
}
